import React from 'react'
import { T } from '@transifex/react'
import { Icon } from '@lightspeed/design-system-react'
import { Currency } from '@vend/business-components'

interface PaymentRequestOverpaymentWarningProps {
  /** Number of pending payment requests */
  pendingCount: number
  /** Total amount of pending payment requests in dollars */
  totalPendingAmount: number
  /** Threshold amount in dollars (sale total - payment request total) */
  thresholdAmount: number
}

export const PaymentRequestOverpaymentWarning: React.FC<PaymentRequestOverpaymentWarningProps> = ({
  pendingCount,
  totalPendingAmount,
  thresholdAmount,
}) => {
  // Don't render if there are no pending requests
  if (pendingCount === 0) {
    return null
  }

  return (
    <div
      style={{
        marginBottom: '12px',
        padding: '12px 16px',
        backgroundColor: '#fce8e6',
        borderRadius: '4px',
        color: '#5f2120',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
      }}
    >
      <Icon
        icon="fa-exclamation-triangle"
        style={{ marginTop: '2px', color: '#e53935' }}
      />
      <div style={{ flex: 1, fontSize: '14px', lineHeight: '1.5' }}>
        <T
          _str="{count, plural, one {You have {count} pending payment request totaling {totalAmount}. Collecting any amount above {threshold} will cancel the payment request.} other {You have {count} pending payment requests totaling {totalAmount}. Collecting any amount above {threshold} will cancel all the payment requests.}}"
          _context="Payment request overpayment warning"
          count={pendingCount}
          totalAmount={<Currency value={totalPendingAmount} />}
          threshold={<Currency value={thresholdAmount} />}
        />
      </div>
    </div>
  )
}
